export const data = [
  {
    text: `
    چه جاده‌های درازی میانِ ما بودند
    که از ونک شروع شده، وَ تا ونیزززز رفته
    
    و احتمال می‌دهم که با شروعِ فاصله‌ها…
    تمامِ خاطراتِ پر از رمز و راز، نیزززز، رفته
    
    دروغِ تلخِ جدایی، دروغ نیست و نبود
    حقیقت است حقیقت،  دهان به چیزززز رفته!
    
    چشانِ کاسه‌ی خون، هی مدام می‌نالند
    چرا نیامده لیلی، یواش،  تیزززز، رفته؟   
    `,
  },
  {
    text: `
    امیدوارم که فرصتی دیگر،
    ببینم‌ات به کناری، کنارِ پستویی
    
    به خویش درکشم‌ات، با فشار و بی‌پروا، 
    شبیه چنگِ عقاب و تنِ پرستویی
    
    شرایطی که در آن پس بگیرم از لبِ تو،
    تمامِ مستنداتِ نژند-بودن را   
                           
    که بشکفی و بِرویی و باغ شوی و شکر،
      شبیه ادکلنِ مستطابِ* صدتویی  
    
    
    مستطاب: خوشایند؛ شایسته.
    `,
  },
  {
    text: `
  چه شعرهای سپیدی در آسمان بودند
  وَ آفتابِ  بهاری به چشم‌ها رفته
  
  نگاهِ  خامِ دو کودک، که بی‌خیالِ جهان…
  نشسته زیر درختِ کجِ زغال‌اخته
  
  سه متر دورتر، میانِ کوچه‌ی تنگ…
  جنازه‌ی زنِ زیبایِ خون به تن لَخته

  وَ من که برایم مهم نیست کسی…
  مسافرم به غزل‌های آخرِ هفته
  `,
  },
  {
    text: `
    درخت‌های سبز و بلند و شیاردار
    در سایه‌شان، زنانِ سپیدپوشِ باردار

    چاقو کشید و پاره کرد حلقِ یاس‌ها
    بیمارِ غیرتی، سگِ هارِ خاردار         
  `,
  },
];
